import { render, staticRenderFns } from "./DepartmentForm.vue?vue&type=template&id=465e3fa6&"
import script from "./DepartmentForm.vue?vue&type=script&lang=ts&"
export * from "./DepartmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports